<template>
<div class="grey lighten-4">
  <v-container ref="contactus">
      <v-row class="align-center">
        <v-col class="col-12 col-sm-12 col-md-4 text-center">
          <v-img src="/almeida.png" width="100%" max-height="250px" contain />
        </v-col>
        <v-col class="col-12 col-sm-12 col-md-4 text-center">
          <span class="colorLogo--text default-home-title text-h4">
            Fale Conosco
          </span>
          <br/>
          <span class="default-home-text text-h6">
            Estamos dispostos a respondê-lo
          </span>
          <br/>
          <v-chip
            color="white"
            class="mt-3"
            target="_blank"
            href="mailto:contato@almeidatech.com">
            <v-icon small color="colorLogo" class="mr-2">mdi-email</v-icon>
            contato@almeidatech.com
          </v-chip>
          <br />
          <v-chip color="white" class="my-3" href="tel:+554840420601">
            <v-icon small color="colorLogo" class="mr-2">mdi-phone</v-icon>
            (48) 4042-0601
          </v-chip>
          <br />
          <v-btn rounded color="white" class="mr-3" href="https://www.facebook.com/Almeida-Technologies-105109664597892">
            <v-icon color="colorLogo">mdi-facebook</v-icon>
          </v-btn>
          <v-btn rounded color="white" class="mr-3" href="https://www.instagram.com/almeida.technologies/">
            <v-icon color="colorLogo">mdi-instagram</v-icon>
          </v-btn>
          <v-btn rounded color="white" class="mr-3" href="https://wa.me/554840420601">
            <v-icon color="colorLogo">mdi-whatsapp</v-icon>
          </v-btn>
        </v-col>
        <v-col class="col-sm-12 col-md-4">
          <v-card>
            <v-form ref="contactUsForm" class="pa-3">
              <v-text-field
                class="my-1"
                outlined
                dense
                v-model="data.name"
                hide-details="auto"
                :disabled="loading"
                label="Nome *"
                :rules="[$rules.required]"
              />
              <div class="d-flex my-1">
                <v-text-field
                  outlined
                  dense
                  v-model="data.email"
                  hide-details="auto"
                  label="E-Mail *"
                  :disabled="loading"
                  :rules="[$rules.email, $rules.required]"
                />
                <v-text-field
                  hide-details="auto"
                  outlined
                  dense
                  v-model="data.phone"
                  class="ml-1"
                  style="max-width: 200px"
                  label="Telefone *"
                  :disabled="loading"
                  v-mask="['(##) #####-####']"
                  :rules="[$rules.phone, $rules.required]"
                />
              </div>
              <v-text-field
                class="my-1"
                dense
                hide-details="auto"
                outlined
                v-model="data.subject"
                :disabled="loading"
                label="Assunto *"
                :rules="[$rules.required]"
              />
              <v-textarea
                class="my-1"
                rows="2"
                auto-grow
                hide-details="auto"
                outlined
                dense
                v-model="data.message"
                :disabled="loading"
                label="Mensagem *"
                :rules="[$rules.required]" 
              />
              <div class="d-flex justify-end mt-3">
                <v-btn  color="colorLogo" :loading="loading" dark @click="sendContactUs()">Enviar</v-btn>
              </div>
            </v-form>
          </v-card>
        </v-col>
      </v-row>
    </v-container> 
  </div>
</template>
<script>
export default {
  data: () => ({
      loading: false,
      data: {
        name: "",
        email: "",
        phone: "",
        newLead: true,
        subject: "",
        message: "",
        tags: [],
    },
  }),

  computed: {
    mobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
};
</script>


<style scoped>
.break {
  word-break: break-word;
}
.title1 {
  font-size: 34px;
  font-weight: bold;
}
.subtitle1 {
  font-size: 21px;
}
</style>
